// @flow
import { Datepicker } from 'fg-frontend/src/components/Datepicker';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/l10n/cs';
// COMMON: Komponenta zajistuje deaktivaci odkazu po prvnim kliknuti
import PreventDoubleClickHandler from 'fg-frontend/src/components/PreventDoubleClickHandler';


import configureEshopComponents from './configureEshopComponents';
import FGUpload from "./components/FGUpload";

export default (props) => {
  switch (props.decorator || props.is) {
    case 'InformationBox':
      return import('./components/InformationBox');
    case 'PreventDoubleClickHandler':
      return PreventDoubleClickHandler;
    case 'AddSvgIconSprite':
      return import('./components/AddSvgIconSprite');
    case 'RadioSelect':
    case 'CheckboxSelect':
      return import('fg-frontend/src/components/RadioSelect');
    case 'SimpleCollapse':
      return import('fg-frontend/components/SimpleCollapse');
    case 'PubTypeahead':
      // COMMON: Komponenta obecneho naseptavace (odeberte, pokud nepouzivate RJ komponentu typeahead nebo v eshopu vychozi naseptavace pobocek dopravnich spolecnosti)
      return import('./components/PubTypeahead');
    case 'Typeahead':
      // COMMON: Komponenta obecneho naseptavace (odeberte, pokud nepouzivate RJ komponentu typeahead nebo v eshopu vychozi naseptavace pobocek dopravnich spolecnosti)
      return import('fg-frontend/components/Typeahead');
    case 'InstagramFeed':
      return import('./components/InstagramFeed');
    case 'GoogleMap':
      return import('./components/GoogleMap');
    case 'GoogleMapFoundation':
      return import('./components/GoogleMapFoundation');
    case 'GoogleMapStoresDetail':
      return import('./components/GoogleMapStoresDetail');
    case 'SelectDesign':
      return import('./components/SelectDesign');
    // case 'ListToggle':
    //   return import('fg-frontend/components/ListToggle');
    case 'PasswordToggle':
      // COMMON: Komponenta pro zapnuti/vypnuti viditelnosti vkladaneho hesla (odeberte, pokud nepouzivate registration modul)
      return import('fg-frontend/components/PasswordToggle');
    // case 'SocialShare':
      // COMMON: Komponenta pro sdileni linku na socialni site (odeberte, pokud nepouzivate sdileni linku na socialni site, napr. v eshopu v detailu produktu)
      // return import('fg-frontend/src/components/SocialShare');
    // case 'AnchorsList':
    //   return import('fg-frontend/src/components/AnchorsList');
    // case 'Slider':
    //   return import('fg-frontend/components/Slider');
    case 'RadioSelectTab':
      return import('fg-frontend/src/components/RadioSelectTab');
    case 'NumberInput':
      return import('fg-frontend/components/NumberInput');
    case 'UniversalPaginationButton':
      return import('fg-frontend/components/UniversalPaginationButton');

    case 'Tooltips':
      return import('./components/Tooltips');
    case 'Tooltip':
      return import('./components/Tooltip');
    case 'GtmHandler':
      return import('./components/GtmHandler');
    case 'TriggerInViewport':
      return import('./components/TriggerInViewport');
    // case 'ShareUrl':
    //   return import('fg-frontend/src/components/ShareUrl');
    case 'PhotoSwipe':
      return import('./components/PhotoSwipe');
    case 'RedirectToUrl':
      return import('fg-frontend/src/components/RedirectToUrl');
    case 'Form':
      return import('./components/Form');
    case 'Faq':
      return import('./components/Faq');
    case 'SearchForm':
      return import('./components/SearchForm');
    case 'LazyImage':
      return import('./components/LazyImage');
    case 'Webslider':
      return import('fg-frontend/src/components/Webslider');
    case 'Datepicker':
      return Datepicker;
    case 'ExcursionDatepicker':
      return import('./components/ExcursionDatepicker');
    case 'Toggler':
      return import('./components/Toggler');
    case 'PrintPage':
      return import('fg-frontend/src/components/PrintPage');
    case 'PrintPdf':
      return import('fg-frontend/src/components/PrintPdf');
    case 'FileInput':
      return import('fg-frontend/src/components/FileInput');
    case 'FoundationStoriesSlider':
      return import('./components/FoundationStoriesSlider');
    case 'FGUpload':
      return FGUpload;
    // case 'ShowMorePhotos':
    //   return import('./components/ShowMorePhotos');
    // case 'RangeSlider':
    //   return import('fg-frontend/src/components/RangeSlider');
    // case 'RangeDatepicker':
    //   return import('fg-frontend/components/RangeDatepicker');
    case 'LangSwitch':
      return import('./components/LangSwitch');
    case 'Header':
      return import('./components/Header');
    case 'HorizontalScroll':
      return import('./components/HorizontalScroll');
    case 'Beer':
      return import('./components/Beer');
    case 'HrCook':
      return import('./components/HrCook');
    case 'BeerRating':
      return import('./components/BeerRating');
    case 'BeerRatingSupport':
      return import('./components/BeerRatingSupport');
    case 'BeerTiles':
      return import('./components/BeerTiles');
    case 'Tabs':
      return import('./components/Tabs');
    case 'ImageParallax':
      return import('./components/ImageParallax');
    case 'AnchorSlider':
      return import('./components/AnchorSlider');
    case 'BeerWidget':
      return import('./components/BeerWidget');
    case 'IntroPage':
      return import('./components/IntroPage');
    case 'AnimateInViewport':
      return import('./components/AnimateInViewport');
    case 'PageTopSlider':
      return import('./components/PageTopSlider');
    case 'GallerySlider':
      return import('./components/GallerySlider');
    case 'VideoPlayer':
      return import('./components/VideoPlayer');
    case 'YouTubeVideo':
      return import('./components/YouTubeVideo');
    case 'LayoutSwitcher':
      return import('./components/LayoutSwitcher');
    case 'ZigZagContentSwitcher':
      return import('./components/ZigZagContentSwitcher');
    case 'ContentAnchors':
      return import('./components/ContentAnchors');
    case 'GoogleRecaptcha':
      // COMMON: Google Recaptcha (odeberte pokud neupouzivate komponentu Google Recaptcha)
      return import('fg-frontend/src/components/GoogleRecaptcha');
    default:
      const eshopComponent = configureEshopComponents(props);
      if (eshopComponent) {
        return eshopComponent;
      } else {
        console.log(`Unknown component ${props.decorator || props.is}`);
        return null;
      }
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js